import React, { useState } from "react";
import { Tabs } from "antd";
import "./style.scss";
import Heading from "../../../components/Heading";
import StaffOnboardingSteps from "./StaffSteps";
import ViewStaffTable from "./viewStaffTable";

const StaffOnboarding = () => {
  const [activeKey, setActiveKey] = useState("1");

  const changeTab = (key) => {
    setActiveKey(key);
    localStorage.setItem("staff", null);
  };

  function handleEdit(params) {
    setActiveKey("1");
    localStorage.setItem("staff", params);
  }

  return (
    <div className="p-2">
      <Heading title="Staff Onboarding" />
      <div className="global-card-tab-container">
        <Tabs
          activeKey={activeKey}
          destroyInactiveTabPane
          onChange={changeTab}
          items={[
            {
              label: "Staff Onboarding",
              key: "1",
              children: <StaffOnboardingSteps changeTab={changeTab} />,
            },
            {
              label: "View All Staff",
              key: "2",
              children: <ViewStaffTable handleEdit={handleEdit} />,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default StaffOnboarding;
